/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetIHDsResponse,
  GetSmartMetersDataFileUrlResponse,
  OfferedAppointment,
  SmAppointmentsHistoryResponse,
  SmEligibilityReasonResponse,
  SmartMeterInterest,
  SmartMeterInterestRequest,
  SmartMetersDashboardDownloadRequest,
  SmartMetersEligibleForExchangeBulkUploadRequest,
  SmartMetersEligibleForExchangeUploadResponse,
  SmartMetersLastSyncedDateTimeResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Download smart meters data.
 */
export const getSmartMetersDataFileUrl = (
  smartMetersDashboardDownloadRequest: SmartMetersDashboardDownloadRequest,
  options?: SecondParameter<
    typeof backofficeRequest<GetSmartMetersDataFileUrlResponse>
  >,
) => {
  return backofficeRequest<GetSmartMetersDataFileUrlResponse>(
    {
      url: `/smart-meters/dashboard/download_url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: smartMetersDashboardDownloadRequest,
    },
    options,
  )
}
/**
 * @summary Get data last updated time.
 */
export const getSyncedDateTime = (
  options?: SecondParameter<
    typeof backofficeRequest<SmartMetersLastSyncedDateTimeResponse>
  >,
) => {
  return backofficeRequest<SmartMetersLastSyncedDateTimeResponse>(
    { url: `/smart-meters/dashboard/get-last-synced-date-time`, method: "GET" },
    options,
  )
}
/**
 * @summary Get appointment history for meters repair/installation.
 */
export const getAppointmentHistory = (
  billingAccountId: string,
  options?: SecondParameter<
    typeof backofficeRequest<SmAppointmentsHistoryResponse>
  >,
) => {
  return backofficeRequest<SmAppointmentsHistoryResponse>(
    {
      url: `/smart-meters/${billingAccountId}/appointment-history`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Get eligibility reason.
 */
export const getEligibilityReason = (
  accountNumber: string,
  options?: SecondParameter<
    typeof backofficeRequest<SmEligibilityReasonResponse>
  >,
) => {
  return backofficeRequest<SmEligibilityReasonResponse>(
    { url: `/smart-meters/${accountNumber}/eligibility-reason`, method: "GET" },
    options,
  )
}
/**
 * @summary Get in home devices by MPXNs
 */
export const getIHDs = (
  mpxns: string,
  options?: SecondParameter<typeof backofficeRequest<GetIHDsResponse>>,
) => {
  return backofficeRequest<GetIHDsResponse>(
    { url: `/smart-meters/in-home-devices/${mpxns}`, method: "GET" },
    options,
  )
}
/**
 * @summary Remove the customer from the smart meter waiting list so they stop receiving appointment availability emails. The registration is not deleted; it is retained as history (status HISTORIC).
 */
export const removeSmartMeterInterest = (
  billingAccountId: string,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/smart-meters/${billingAccountId}/register-interest`,
      method: "DELETE",
    },
    options,
  )
}
/**
 * @summary Get registered interest for smart meter.
 */
export const getSmartMeterInterest = (
  billingAccountId: string,
  options?: SecondParameter<typeof backofficeRequest<SmartMeterInterest>>,
) => {
  return backofficeRequest<SmartMeterInterest>(
    {
      url: `/smart-meters/${billingAccountId}/register-interest`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Save interest for smart meter.
 */
export const saveSmartMeterInterest = (
  billingAccountId: string,
  smartMeterInterestRequest: SmartMeterInterestRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/smart-meters/${billingAccountId}/register-interest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: smartMeterInterestRequest,
    },
    options,
  )
}
/**
 * @summary Get the offered appointments via SMBP, IMBP and Emails
 */
export const getOfferedAppointments = (
  billingAccountId: string,
  options?: SecondParameter<typeof backofficeRequest<OfferedAppointment[]>>,
) => {
  return backofficeRequest<OfferedAppointment[]>(
    {
      url: `/smart-meters/${billingAccountId}/appointments-offered`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Bulk upload smart meters eligible for exchange.
 */
export const uploadSmartMetersEligibleForExchange = (
  smartMetersEligibleForExchangeBulkUploadRequest: SmartMetersEligibleForExchangeBulkUploadRequest,
  options?: SecondParameter<
    typeof backofficeRequest<SmartMetersEligibleForExchangeUploadResponse>
  >,
) => {
  return backofficeRequest<SmartMetersEligibleForExchangeUploadResponse>(
    {
      url: `/smart-meters/eligible-for-exchange/bulk-upload`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: smartMetersEligibleForExchangeBulkUploadRequest,
    },
    options,
  )
}
export type GetSmartMetersDataFileUrlResult = NonNullable<
  Awaited<ReturnType<typeof getSmartMetersDataFileUrl>>
>
export type GetSyncedDateTimeResult = NonNullable<
  Awaited<ReturnType<typeof getSyncedDateTime>>
>
export type GetAppointmentHistoryResult = NonNullable<
  Awaited<ReturnType<typeof getAppointmentHistory>>
>
export type GetEligibilityReasonResult = NonNullable<
  Awaited<ReturnType<typeof getEligibilityReason>>
>
export type GetIHDsResult = NonNullable<Awaited<ReturnType<typeof getIHDs>>>
export type RemoveSmartMeterInterestResult = NonNullable<
  Awaited<ReturnType<typeof removeSmartMeterInterest>>
>
export type GetSmartMeterInterestResult = NonNullable<
  Awaited<ReturnType<typeof getSmartMeterInterest>>
>
export type SaveSmartMeterInterestResult = NonNullable<
  Awaited<ReturnType<typeof saveSmartMeterInterest>>
>
export type GetOfferedAppointmentsResult = NonNullable<
  Awaited<ReturnType<typeof getOfferedAppointments>>
>
export type UploadSmartMetersEligibleForExchangeResult = NonNullable<
  Awaited<ReturnType<typeof uploadSmartMetersEligibleForExchange>>
>
